export namespace TranslationUtils {

  export async function useTranslation(locale: string) {
    let data: { translation: Record<string, string> } | undefined;
    if (locale === 'ar') {
      data = (await import('./i18n/ar.json')).default;
    }
    return (text: string): string => data?.translation[text] ?? text;
  }

}
